import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@/admin/components/Card/Card';
import CardData from '@/admin/components/CardData/CardData';
import AccountHistoryCard from '@/admin/components/AccountDetailsPage/AccountHistoryCard';
import { SchoolDetails } from '@/admin/config/listConfig';
import { formatDate } from '@/utils/formatters';
import styles from '@/components/school-management/SchoolDetailsPage/styles.module.scss';
import classes from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';

interface GeneralDetailsProps {
  school: SchoolDetails;
  apiData?: any;
  schoolId?: string;
}

const GeneralDetails: React.FC<GeneralDetailsProps> = ({ school, apiData, schoolId }) => {
  const navigate = useNavigate();
  const schoolData = apiData?.data?.data?.school;
  const schoolConfig = apiData?.data?.data?.schoolConfig;
  const schoolStatistics = apiData?.data?.data?.statistics || {};
  const { t } = useAdminTranslation();

  if (!schoolData) {
    return (
      <Card className={styles.detailsCard}>
        <div className={styles.cardHeader}>
          <span className={styles.sectionTitle}>General Details</span>
        </div>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          Backend data not available - please check your API connection
        </div>
      </Card>
    );
  }

  const details = [
    {
      label: t('schoolDetailsPage.general.country'),
      value: schoolData.country || '-',
      type: 'Default' as const,
    },
    {
      label: t('state'),
      value: schoolData.state,
      type: 'Default' as const,
    },
    {
      label: t('city'),
      value: schoolData.city || '-',
      type: 'Default' as const,
    },
    {
      label: t('schoolDetailsPage.general.expirationDate'),
      value: schoolConfig?.expirationDate ? formatDate(schoolConfig.expirationDate) : '-',
      type: 'Default' as const,
    },
    // {
    //   label: 'School Admin name',
    //   value: schoolData.schoolManagerName || '-',
    //   type: 'Default' as const,
    // },
    // {
    //   label: 'School Admin email',
    //   value: schoolData.schoolManagerEmail || '-',
    //   type: 'Default' as const,
    // },
    // {
    //   label: 'School Admin Status',
    //   value: schoolData.schoolManagerStatus === 'active' ? 'Active' : 'Inactive',
    //   type:
    //     schoolData.schoolManagerStatus === 'active'
    //       ? ('Default' as const)
    //       : ('Alert' as const),
    //   status: (schoolData.schoolManagerStatus === 'active' ? 'ACTIVE' : 'INACTIVE') as
    //     | 'ACTIVE'
    //     | 'INACTIVE',
    //   hint:
    //     schoolData.schoolManagerStatus !== 'active' ? (
    //       <>
    //         Click{' '}
    //         <a
    //           href='#'
    //           onClick={() => {
    //             navigate('/resend-password');
    //           }}
    //         >
    //           here
    //         </a>{' '}
    //         to resend temporary password
    //       </>
    //     ) : undefined,
    //   linkText: schoolData.schoolManagerStatus !== 'active' ? 'here' : undefined,
    //   onLinkClick:
    //     schoolData.schoolManagerStatus !== 'active'
    //       ? () => {
    //           navigate('/resend-password');
    //         }
    //       : undefined,
    // },
    {
      label: t('schoolDetailsPage.general.totalTeachers'),
      value: schoolData.numberOfTeachers?.toString() || '-',
      type: 'Default' as const,
    },
    {
      label: t('schoolDetailsPage.general.totalClasses'),
      value: schoolData.numberOfClasses?.toString() || '-',
      type: 'Default' as const,
    },
    {
      label: t('schoolDetailsPage.general.totalStudents'),
      value: schoolData.numberOfStudents?.toString() || '-',
      type: 'Default' as const,
    },
    ...(typeof schoolStatistics.usersLimit === 'number'
      ? [
          {
            label: t('schoolDetailsPage.general.licensesUsage'),
            value: (
              <span
                className={classes({
                  [styles.detailsCardAlertValue]:
                    (schoolStatistics.usersUsed || 0) >= (schoolStatistics.usersLimit || 0),
                })}
              >{`${schoolStatistics.isSharedPool ? '*' : ''}${schoolStatistics.usersUsed || 0}/${schoolStatistics.usersLimit || 0}`}</span>
            ),
            type: 'Default',
            hint: schoolStatistics.isSharedPool && t('schoolDetailsPage.general.sharedLicenseHint'),
          },
        ]
      : []),
  ];

  return (
    <>
      <Card className={styles.detailsCard} style={{ gridColumn: '1/3' }}>
        <div className={styles.cardHeader}>
          <span className={styles.sectionTitle}>{t('schoolDetailsPage.general.title')}</span>
        </div>
        {details.map(item => {
          const { status, ...rest } = item as any;
          return (
            <CardData
              key={item.label}
              {...rest}
              {...(status === 'ACTIVE' || status === 'INACTIVE' ? { status } : {})}
              style={{ padding: '9px 0 0 ', marginTop: '9px' }}
            />
          );
        })}
      </Card>
    </>
  );
};

export default GeneralDetails;
